import {
   closeWebView,
   customBackPress,
   getLoggedInNumber,
   isMobileApp,
   isNewIOSApp,
   showAppToolBar,
} from '@airtel-lego/native-app-bridge';
import { Artist } from '@airtel/air-artist';
import { debounce, RED_500, StateConfigProvider, useBreakpoint } from '@airtel/air-design-system';
import { getLoggedInUser, isUserLoggedIn } from '@airtel/air-utils';
import { FC, Suspense, lazy, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { fireLogWithSentryBase } from '@airtel-lego/sentry';

import {
   callCreateCommonIntentApi,
   callCreateCommonIntentBundlingApi,
   checkDomain,
   checkValidDetails,
   filterPlanList,
   getFromSessionStorage,
   handleCoipOnLoad,
   handleExitIntentFeedbackSelect,
   handleExitIntentOnSubmit,
   handleGtmDataLayerEvent,
   handleHomeNavigation,
   handleRedirectionOnOmniWidgetAddress,
   isSessionSupported,
   otpConsentAction,
   pseudoOnLoadAddDetails,
   redirectToNonP2p,
   savedLoggedInSiNumberAndPrefillInput,
   selectPlanDetailsJourney,
   selectPlanListingJourney,
   sendmessage,
   setJourneyTypeInSessionStorage,
   showOfferCard,
   updateAnalyticsData,
   updatePathParams,
   updatePlanChange,
   updateQueryParams,
   useQuery,
   callFetchManageDetails,
   handleWebViewCloseActionForManageAddOnThanksPage,
   resetOnWebViewCloseCallback,
   redirectToSkyc,
   initializeManageChildJourney,
   scrollingIntoView,
   getContactsUtil,
   generateChangeActions, 
   getContactsUtilP2P,
   handleAddOnDetailsOnLoad,
   handleTabChange,
   redirectToP2PPage,
   updateIsBundlingAppliedInRedux,
   updatePlanDetailsOnBundlingApplied,
   handleMarkFirebaseEvent,
   callOtpShiftLoaderActions,
   checkAuthFlow
} from '../../common/commonUtils';
import { isNewConnectionRoute } from '../../common/environment';
import {
   callLoginSendOtpApi,
   // callLoginSendOtpApi,
   prepareLoginValidateOtpApi,
   redirectToHomeApi,
   storeTokens,
   tokensHandlerOnReload,
   // updateLeadBody,
   useParamAndFindBundling,
} from '../../common/otpUtils';
import {
   ADD_DETAILS_INTENTS_MAPPING,
   API_CONFIGS,
   BUTTON_THEME_CONFIG,
   LOGIN_CONSTANTS,
   PUBLIC_KEY_URL,
   getQueryString,
} from '../../constants/AppConstants';
import { PAGESPACE_PAGES } from '../../constants/RouteConstants';
import {
   createBundleQLNN,
   createCartObj,
   handleBundledFlowLogic,
} from '../../utils/cartUtil';
import {
   callPaymentonFailure,
   handleThanksPageOnLoad,
   navigateToPayment,
} from '../../utils/paymentUtils';
// import { Shimmer } from '../shimmer';
import { fireDynamicEvents, fireDynamicEventsUtil } from '../../utils';
import { LayoutPropTypes } from './LayoutPropTypes';
import { navigateToPaymentQC } from '../../utils/quickCheckoutUtils';


const usePageViews = () => {
   let location = useLocation();
   useEffect(() => {
      // remove old overlay class
      const htmlElement = document.getElementsByTagName('html');
      htmlElement[0]?.classList?.remove?.('omni-overflow');
   }, [location]);
};

const Footer = lazy(() => import('./Footer'));
const Header = lazy(() => import('./Header'));

export const Layout: FC<LayoutPropTypes> = (props) => {
   const isOmniWidgetBackdropEnabled = useRef(false);
   const {
      hideAllLinks,
      showHeader = true,
      showFooter = false,
      currPage,
      className = '',
   } = props;
   const { isLargeScreen } = useBreakpoint({ returnAsObject: true });
   const gclId = useQuery().get('gclid') || '';
   const fbclId = useQuery().get('fbclid') || '';
   const clickId = gclId || fbclId || '';
   const navigate = useNavigate();
   const [searchParams] = useSearchParams();
   const location = useLocation();
   usePageViews(); // to remove omni widget overflow hidden class

   const [isLoading, setIsLoading] = useState(true);
   const [isLoggedIn, setIsLoggedIn] = useState(false);
   const artistRef = useRef<any>();
   const isApp = isMobileApp();
   const isNotLoadingAndisWeb = !(isApp || isLoading);
   const { intent } = useParams();
   const userType = useQuery().get('usertype');

   const additionalData = useMemo(
      () => ({
         queryParams: Object.fromEntries(searchParams.entries()),
      }),
      [searchParams.toString()]
   );

   const isWidget = isSessionSupported() ? getFromSessionStorage('isWidget') : false;

   useEffect(() => {
console.log("p2p otp at black testing111....");
     
      const checkOmniEventBackdrop = (e: MessageEvent<any>) => {
         const omniWidgetEventName = e?.data?.eventName;
         if (omniWidgetEventName === 'WtoC_EnableBackdrop') {
            isOmniWidgetBackdropEnabled.current = true;
         }
         if (omniWidgetEventName === 'WtoC_DisabledBackdrop') {
            isOmniWidgetBackdropEnabled.current = false;
         }
      };
      window.addEventListener('message', checkOmniEventBackdrop);
      return () => {
         window.removeEventListener('message', checkOmniEventBackdrop);
      };
   }, []);

   useEffect(() => {
      const iframeIntent = Object.fromEntries(searchParams.entries())['dynamicheight'];
      const widgetBody = document.body;

      if (iframeIntent) {
         let resizeObserver = new ResizeObserver(
            debounce((entries: ResizeObserverEntry[]) => {
               let height = entries?.[0]?.contentBoxSize?.[0]?.blockSize;
               if (isOmniWidgetBackdropEnabled.current) height += 80;
               sendmessage({ height });
            }, 500)
         );
         widgetBody.style.height = 'auto';
         const rendeContainer = document.querySelectorAll('.renderer-container');
         const firstRendeContainer = rendeContainer?.[0] as HTMLElement;

         if (isWidget) {
            const firstChildNodes = rendeContainer?.[0]?.childNodes?.[0] as HTMLElement;
            if (firstChildNodes?.style) firstChildNodes.style.minHeight = 'auto';
         }

         if (firstRendeContainer?.style) firstRendeContainer.style.minHeight = 'auto';
         resizeObserver.observe(widgetBody);
         return () => {
            resizeObserver.unobserve(widgetBody);
         };
      }
   }, [searchParams.toString()]);

   useEffect(() => {

      fetchPublicKey();
      if (isMobileApp()) {
         const { channel, journey } = getQueryString();
         let channelFromSession = window?.sessionStorage?.getItem("channel")
         if (window.location && window.location.pathname?.includes("add-connection") && channel == "THANKS_APP") {
            if (!isNewIOSApp()) { //TODO need to remove this check once IOS app releases
               customBackPress?.(() => handleWebViewCloseActionForManageAddOnThanksPage())
            }
         }
         if (window.location && (window.location.pathname?.includes("thank-you") || window.location.pathname?.includes("thanks-add-child-details-new")) && channelFromSession == "THANKS_APP" && journey == "addOn") {
            if (isMobileApp()) {
               let callback = () => {
                  if (isNewIOSApp()) {
                     //@ts-ignore
                     window?.webkit?.messageHandlers?.openDeeplink?.postMessage("myairtel://home")
                  }
                  else {
                     //@ts-ignore
                     window?.MyAirtelAppReact?.launch("myairtel://home")
                  }
               }
               if (!isNewIOSApp()) { //TODO need to remove this check once IOS app releases
                  customBackPress?.(() => callback())
               }
            }
         }
      }
      if(additionalData?.queryParams?.utm_variant ==='otp_at_end_priority_postpaid'){
      showAppToolBar(false,true)
      }
   }, []);

   useEffect(() => {
      const updatedIntent = intent && ADD_DETAILS_INTENTS_MAPPING[intent];
      let value: any = {
         isNewConnection: isNewConnectionRoute(),
      };

      if (updatedIntent) {
         if (additionalData?.queryParams?.intent !== updatedIntent) {
            value = {
               ...value,
               type: updatedIntent,
            };
         }
      } else if (additionalData?.queryParams?.intent) {
         value = {
            ...value,
            type: additionalData?.queryParams?.intent,
         };
      }
      artistRef.current?.onUserAction?.({
         actions: [
            {
               type: 'setDataInSessionStorage',
               target: 'session',
               payload: {
                  key: 'intentSelected',
                  value,
                  clearOnLogout: false,
               },
            },
         ],
      });
   }, [intent, additionalData?.queryParams?.intent]);

   const fetchPublicKey = async () => {
      fetch(PUBLIC_KEY_URL)
         .then((response) => {
            return response.text();
         })
         .then((data) => {
            //store the key in local storage
            localStorage.setItem('key', data);
         })
         .catch((error) => {
            // handle the error
            //call sentry
         });
   };

   const callbackHandler = (_isLoading: any) => {
      if (!_isLoading) {
         if (isApp) {
            getLoggedInNumber()
               .then((number) => {
                  artistRef.current?.onUserAction(
                     savedLoggedInSiNumberAndPrefillInput(number, true)
                  );
               })
               .finally(() => {
                  setIsLoading(_isLoading);
               });
         } else {
            const isWebLoggedInUser = isUserLoggedIn();
            if (isWebLoggedInUser) {
               artistRef.current?.onUserAction(
                  savedLoggedInSiNumberAndPrefillInput(
                     getLoggedInUser(),
                     isWebLoggedInUser,
                     true
                  )
               );
            } else {
               artistRef.current?.onUserAction(
                  savedLoggedInSiNumberAndPrefillInput('', false)
               );
            }
            setIsLoading(_isLoading);
         }
      } else {
         setIsLoading(_isLoading);
      }
   };

   useEffect(() => {
      if (isApp || isUserLoggedIn()) {
         setIsLoggedIn(true);
      }
   }, []);

   const removeDummyContentLoader = () => {
      try {
         const initLoaderSelectors = ['#init-loader', '#init-loader-priority'];
         initLoaderSelectors.forEach((selector) => {
            const initLoader: any = document.querySelector(selector);
            if (initLoader) {
               document.body.removeChild(initLoader);
            }
         });
      } catch (error) {
         //
      }
   };

   useEffect(() => {
      if (!isLoading) removeDummyContentLoader();
   }, [isLoading]);

   const globalAnalyticsObject = () => {
      let baseObj: any = {
         journey: 'postpaid-purchase',
         googleClickId: clickId,
         prop28: getQueryString()?.agentId || ''
      };

      return baseObj;
   };

   const setAnalyticsProps = (currPage?: string) => {
      try {
         const obj = {
            prop6: "",
            prop14: "",
            prop11: ""
         };

         const sessionData: any = JSON.parse(
            sessionStorage.getItem('aa-postpaid-purchase') as any
         );
         const tokenData: any = JSON.parse(
            sessionStorage.getItem(LOGIN_CONSTANTS.coipGroupId) as any
         );

         if (
            userType === 'COIP' ||
            currPage?.toLowerCase() === 'coip_ingress_landing_page'
         ) {
            obj.prop14 = tokenData?.email;
            obj.prop6 = 'coip';
         }

         sessionStorage.setItem('aa-postpaid-purchase', JSON.stringify({
            ...sessionData,
            ...obj
         }))

      } catch (error) {
         fireLogWithSentryBase(
            'layout.ts-->setAnalyticsProps-->error while setting analytics props on page change',
            error
         );
      }
   }

   useEffect(() => {
      setAnalyticsProps(currPage);
   }, [currPage])

   useEffect(() => {
      setTimeout(()=>{
         // to fire dynamic event for chatbot on thanks app
      const pathName = location.pathname?.split('/')?.slice(-1)?.[0];
      const mapping: any = {
         'thank-you': 'FAMILY_THANKYOU_SIT',
         'thanks-add-child-details-new': 'FAMILY_ADD_DETAILS_CHILD_THANKS_PAGE'
      }
      if (mapping[pathName]) {
         const mobileNumber = getFromSessionStorage('mobileNumber');
         const otpAtEndContext = getFromSessionStorage('otpAtEndContext')
         const otpAtEnd = otpAtEndContext?.otpAtEnd || false

         if (mobileNumber) {
               fireDynamicEventsUtil({args :[
                  {
                  siNumber : mobileNumber?.toString(), 
                  state : 'PAGE_LOAD',
                  pageName : mapping[pathName] ,
                  otpAtEnd : otpAtEnd
                  }
               ]});   
         }
      }}
   ,1000)
      
   }, [location.pathname]);

   const artist = useMemo(() => {
      const isProduction = window?.location?.origin?.includes('www.airtel.in');
      return (
         <div
            className={`renderer-container ${className} ${isLoading ? 'renderer-container-loading' : ''
               } ${currPage === 'common_add_details_page' && isLargeScreen
                  ? 'renderer-container-with-sticky-bottom'
                  : ''
               }`}
         >
            <Artist
               ref={artistRef}
               apiConfig={API_CONFIGS}
               analyticsEnv={isProduction ? 'PROD' : 'KONGQA'}
               pagesToLoad={PAGESPACE_PAGES}
               currPage={currPage}
               getPageLoadingStatus={callbackHandler}
               additionalData={additionalData}
               globalAnalyticsAttributes={globalAnalyticsObject()}
               utilFunctions={{
                  navigate,
                  closeWebView: () => {
                     closeWebView?.();
                  },
                  payment: ({ onUserAction, actionContextData, getState }: any) => {
                     navigateToPayment(onUserAction, actionContextData, getState);
                  },
                  quickCheckout: ({ onUserAction, actionContextData, getState }: any) => {
                     navigateToPaymentQC(onUserAction, actionContextData, getState);
                  },
                  validateThankYouPage: ({ onUserAction, getState }: any) => {
                     handleThanksPageOnLoad(onUserAction, getState);
                  },
                  callSendOtp: ({ args, onUserAction, getState }: any) => {
                     callLoginSendOtpApi(args, onUserAction, getState);
                  },
                  useParamAndFindBundling: ({ args, onUserAction, getState }: any) => {
                     useParamAndFindBundling(args, onUserAction, getState);
                  },
                  scrollingIntoView: ({ args }: any) => {
                     const testId = args?.testId || args?.[0];
                     scrollingIntoView(testId);
                  },
                  redirectToHome: ({ args, onUserAction, getState }: any) => {
                     redirectToHomeApi(args, onUserAction, getState);
                  },
                  validateOtp: ({ args, onUserAction, getState }: any) => {
                     prepareLoginValidateOtpApi(args, onUserAction, getState);
                  },
                  storeTokensandCallApi: ({ args, onUserAction, getState }: any) => {
                     storeTokens(args, onUserAction, getState);
                  },
                  updateTokensInRedux: ({
                     onUserAction,
                     actionContextData,
                     getState,
                  }: any) => {
                     tokensHandlerOnReload(onUserAction, actionContextData, getState);
                  },

                  showGraffitiAndOfferCard: ({
                     args,
                     onUserAction,
                     actionContextData,
                     getState,
                  }: any) => {
                     showOfferCard(args, actionContextData, onUserAction, getState);
                  },
                  checkBundleTypeAndCreateUQL: ({
                     args,
                     onUserAction,
                     actionContextData,
                     getState,
                  }: any) => {
                     createCartObj(args, onUserAction, actionContextData, getState);
                  },
                  filterPlanList: ({
                     onUserAction,
                     actionContextData,
                     getState,
                  }: any) => {
                     filterPlanList(onUserAction, actionContextData, getState);
                  },
                  pseudoOnLoadAddDetails: ({ onUserAction, getState }: any) => {
                     pseudoOnLoadAddDetails(onUserAction, getState);
                  },
                  handleBundledQL: ({
                     args,
                     onUserAction,
                     actionContextData,
                     getState,
                  }: any) => {
                     handleBundledFlowLogic(
                        args,
                        onUserAction,
                        actionContextData,
                        getState
                     );
                  },
                  handleHomeNavigation: ({ onUserAction, args }: any) => {
                     handleHomeNavigation(onUserAction, args);
                  },

                    checkAuthFlow: ({ onUserAction, args }: any) => {
                     checkAuthFlow(onUserAction);
                  },

                 
                  callPaymentonFailure: ({ onUserAction }: any) => {
                     callPaymentonFailure(onUserAction);
                  },
                  handleRedirectionOnPage: ({
                     args,
                     actionContextData,
                     onUserAction,
                     getState,
                  }: any) => {
                     handleRedirectionOnOmniWidgetAddress(args, onUserAction, getState);
                  },
                  selectPlanDetailsJourney: ({ onUserAction }: any) => {
                     selectPlanDetailsJourney(onUserAction);
                  },
                  selectPlanListingJourney: ({ onUserAction }: any) => {
                     selectPlanListingJourney(onUserAction);
                  },
                  handleNNBundleQL: ({
                     args,
                     actionContextData,
                     onUserAction,
                     getState,
                  }: any) => {
                     createBundleQLNN(args, actionContextData, onUserAction, getState);
                  },
                  otpConsentAction: ({
                     args,
                     actionContextData,
                     onUserAction,
                     getState,
                  }: any) => {
                     otpConsentAction(args, getState, onUserAction, actionContextData);
                  },
                  updateAnalyticsData: ({
                     args,
                     actionContextData,
                     onUserAction,
                     getState,
                  }: any) => {
                     updateAnalyticsData(args, getState, onUserAction);
                  },
                  updatePlanChange: ({ onUserAction, getState }: any) => {
                     updatePlanChange(onUserAction, getState);
                  },
                  checkValidDetails: ({ onUserAction, getState }: any) => {
                     checkValidDetails(onUserAction, getState);
                  },
                  checkDomain: ({ onUserAction, getState }: any) => {
                     checkDomain(onUserAction, getState);
                  },
                  handleExitIntentSubmit: ({ onUserAction, getState }: any) => {
                     handleExitIntentOnSubmit(onUserAction, getState)
                  },
                  handleExitIntentFeedbackSelect: ({ onUserAction, getState, args }: any) => {
                     handleExitIntentFeedbackSelect(onUserAction, getState, args)
                  },
                  setJourneyTypeInSessionStorage: ({ onUserAction }: any) => {
                     setJourneyTypeInSessionStorage(onUserAction);
                  },
                  redirectToNonP2p: ({ onUserAction, getState }: any) => {
                     redirectToNonP2p(onUserAction, getState);
                  },
                  redirectToSkyc,
                  checkCoipOnReload: ({ onUserAction }: any) => {
                     handleCoipOnLoad(onUserAction);
                  },
                  updateQueryParams,
                  updatePathParams: ({ args }: any) => {
                     updatePathParams({
                        args,
                        navigate,
                        location,
                     });
                  },
                  getContactsUtil: ({ onUserAction }: any) => {
                     getContactsUtil(onUserAction)
                  },
                  getContactsUtilP2P: ({ onUserAction }: any) => {
                     getContactsUtilP2P(onUserAction)
                  },
                  callCreateCommonIntentApi,
                  callCreateCommonIntentBundlingApi,
                  handleGtmDataLayerEvent,
                  callFetchManageDetails,
                  resetOnWebViewCloseCallback,
                  initializeManageChildJourney,
                  fireDynamicEventsUtil,
                  handleWebViewCloseActionForManageAddOnThanksPage,
                  generateChangeActions,
                  handleAddOnDetailsOnLoad,
                  handleTabChange,
                  redirectToP2PPage,
                  markFirebaseEvent: ({ args, getState }: any) => {
                     handleMarkFirebaseEvent(args, getState);
                  },
                  updateIsBundlingAppliedInRedux : ({ args, onUserAction, getState }: any) => {
                     updateIsBundlingAppliedInRedux(args, onUserAction, getState);
                  },
                  updatePlanDetailsOnBundlingApplied,
                  callOtpShiftLoaderActions : ({ args, onUserAction, getState }: any) => {
                     callOtpShiftLoaderActions( args, onUserAction, getState );
                  }
               }}
            />
         </div>
      );
   }, [currPage, isLoading, JSON.stringify(additionalData)]);

   return (
      <Suspense fallback={null}>
         {!isWidget && isNotLoadingAndisWeb && showHeader && (
            <Header isLoggedIn={isLoggedIn} />
         )}

         {/* shimmer skeleton loader */}
         {/* {isLoading && <Shimmer />} */}

         {/* artist component */}
      <StateConfigProvider config={BUTTON_THEME_CONFIG}>{artist}</StateConfigProvider>
         {isNotLoadingAndisWeb && showFooter && <Footer hideAllLinks={hideAllLinks} />}
      </Suspense>
   );
};
